// extracted by mini-css-extract-plugin
module.exports = {"jobSearchDetail-sectionItem__sectionItemPosition":"jobSearchDetail-sectionItem__sectionItemPosition"};